import { AVATARS, AVATAR_COLORS } from '@oefy/core';
import { z } from 'zod';
import { schoolGroupSchema } from './common';

export const emailSchema = z.string().trim().toLowerCase().pipe(z.email().max(254));

export const requestLoginCodeSchema = z.object({
  email: emailSchema,
});

export const signInSchema = z.object({
  email: emailSchema,
  code: z
    .string()
    .trim()
    .regex(/^\d{6}$/),
});

export const signInLinkSchema = z.object({
  token: z
    .string()
    .trim()
    .regex(/^[A-Za-z0-9_-]{32,128}$/),
});

export const userRoleSchema = z.enum(['parent', 'staff']);

export const avatarSchema = z.enum(AVATARS);
export const avatarColorSchema = z.enum(AVATAR_COLORS);

export const childProfileSchema = z.object({
  id: z.uuid(),
  firstName: z.string(),
  schoolGroup: schoolGroupSchema,
  textScale: z.int().min(-1).max(2),
  avatar: avatarSchema,
  avatarColor: avatarColorSchema,
  photoUrl: z.string().nullable(),
});

export const sessionUserSchema = z.object({
  id: z.uuid(),
  email: z.string(),
  name: z.string().nullable(),
  photoUrl: z.string().nullable(),
  role: userRoleSchema,
  admin: z.boolean(),
  children: z.array(childProfileSchema),
});

export type RequestLoginCodeInput = z.infer<typeof requestLoginCodeSchema>;
export type SignInInput = z.infer<typeof signInSchema>;
export type SignInLinkInput = z.infer<typeof signInLinkSchema>;
export type UserRole = z.infer<typeof userRoleSchema>;
export type ChildProfile = z.infer<typeof childProfileSchema>;
export type SessionUser = z.infer<typeof sessionUserSchema>;
